function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7593 52.1848H49.7593V25.5267L33.2593 10.7555L16.7593 25.5267V52.1848ZM52.5093 57.6015H14.0093C13.2799 57.6015 12.5805 57.3162 12.0647 56.8083C11.549 56.3004 11.2593 55.6115 11.2593 54.8932V30.5182H3.00928L31.4085 5.09234C31.9148 4.63864 32.5747 4.38721 33.2593 4.38721C33.9438 4.38721 34.6037 4.63864 35.11 5.09234L63.5093 30.5182H55.2593V54.8932C55.2593 55.6115 54.9695 56.3004 54.4538 56.8083C53.9381 57.3162 53.2386 57.6015 52.5093 57.6015ZM20.8843 35.9348H26.3843C26.3843 37.7306 27.1086 39.4528 28.3979 40.7225C29.6872 41.9923 31.4359 42.7057 33.2593 42.7057C35.0826 42.7057 36.8313 41.9923 38.1206 40.7225C39.4099 39.4528 40.1343 37.7306 40.1343 35.9348H45.6343C45.6343 39.1672 44.3305 42.2671 42.0097 44.5527C39.689 46.8383 36.5413 48.1223 33.2593 48.1223C29.9772 48.1223 26.8296 46.8383 24.5088 44.5527C22.1881 42.2671 20.8843 39.1672 20.8843 35.9348Z",
  fill: "white"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.499948f3.svg";
export { ForwardRef as ReactComponent };